import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Returns a function that always brings the user to the homepage contact form.
 * - On `/`, it smooth-scrolls to #contact.
 * - On any other route, it navigates to `/#contact` and HashScroller (in App.js)
 *   handles the smooth scroll once the homepage mounts.
 */
export const useGoToContact = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return () => {
    if (location.pathname === '/') {
      const el = document.getElementById('contact');
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      navigate('/#contact');
    }
  };
};
